module.exports = __webpack_public_path__ + "img/MurrayPozmanter@2x.fd8d0729.png";